<template>
    <div>
        <ValidationObserver ref="formModalValidate">

            <b-row>
                <b-col cols="12" md="6">
                    <ValidationProvider name="expected_release_date" rules="required" v-slot="{ errors }">
                        <b-form-group :label="$t('expected_release_date')">
                            <select-date v-model="formData.expected_release_date"
                                         :state="errors[0] ? false : null"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="file" rules="required" v-slot="{errors}">
                        <b-form-group :label="$t('bau_i20_file')">
                            <div class="d-flex custom-file-upload">
                                <b-form-file
                                    v-model="formData.file"
                                    accept=".pdf,.docx,.xlsx,.png,.jpg,.jpeg"
                                    :placeholder="$t('select_file')"
                                    ref="fileInput"
                                ></b-form-file>
                                <b-button variant="outline-secondary" @click="$refs.fileInput.$el.childNodes[0].click();">{{ $t('browse') }}</b-button>
                            </div>
                            <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="eligibility_file" rules="" v-slot="{errors}">
                        <b-form-group :label="$t('eligibility_file')">
                            <div class="d-flex custom-file-upload">
                                <b-form-file
                                    v-model="formData.eligibility_file"
                                    accept=".pdf,.docx,.xlsx,.png,.jpg,.jpeg"
                                    :placeholder="$t('select_file')"
                                    ref="fileInputEligibility"
                                ></b-form-file>
                                <b-button variant="outline-secondary" @click="$refs.fileInputEligibility.$el.childNodes[0].click();">{{ $t('browse') }}</b-button>
                            </div>
                            <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
            <div class="d-flex justify-content-center mt-2">
                <processing-button :label="$t('save')" :processing="formLoading" @click="updateForm"/>
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
// Components
import ProcessingButton from "@/components/elements/ProcessingButton.vue";
// Services
import TransferOutRequestMentora from "@/services/TransferOutRequestMentora";

// Other
import {ValidationProvider, ValidationObserver} from "vee-validate"


export default {
    components: {
        ProcessingButton,
        ValidationProvider,
        ValidationObserver,
    },
    props: {
        formId: {
            type: Number,
        }
    },
    data() {
        return {
            formData: {
                file: null,
                eligibility_file: null,
                expected_release_date: null
            },
            formLoading: false,
        }
    },
    methods: {
        async updateForm() {
            const isValid = await this.$refs.formModalValidate.validate();
            if (!isValid) {
                return;
            }

            this.$swal.fire({
                title: this.$t('warning'),
                text: this.$t('leave_of_absence_statement'),
                showCancelButton: true,
                confirmButtonText: this.$t('yes'),
                cancelButtonText: this.$t('no'),
            }).then((result) => {
                if (!result.isConfirmed) {
                    return;
                }

                this.formLoading = true

                if (this.checkPermission('transferoutrequest_savedsorelease')) {

                    const formData = new FormData();
                    const file = this.formData.file;
                    if(file) {
                        formData.append('file', file);
                    }
                    const eligibilityFile = this.formData.eligibility_file;
                    if(eligibilityFile) {
                        formData.append('eligibility_file', eligibilityFile);
                    }
                    formData.append('expected_release_date', this.formData.expected_release_date);
                    formData.append('_method','PUT')

                    TransferOutRequestMentora.saveDsoRelease(this.formId, formData)
                        .then(response => {
                            this.$emit('updateFormSuccess', true);
                            this.$toast.success(this.$t('api.' + response.data.message));
                        })
                        .catch(error => {
                            this.showErrors(error, this.$refs.formModalValidate)
                        })
                        .finally(() => {
                            this.formLoading = false
                        });
                }
            })
        }
    }
}
</script>
